import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, TextField, Snackbar, Alert, FormControl, InputLabel } from '@mui/material';
import { db } from '../firebaseConfig'; // Adjust the import based on your project structure
import { doc, getDoc, updateDoc } from 'firebase/firestore'; // Import updateDoc
import { getAuth } from 'firebase/auth';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'; // Import DatePicker
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // Date adapter

const AddClass = () => {
  const [classes, setClasses] = useState([]); // State to hold classes
  const [className, setClassName] = useState('');
  const [presenter, setPresenter] = useState('');
  const [dateOfClass, setDateOfClass] = useState(null); // Use null for date
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const docRef = doc(db, 'hvac', 'GenericData', 'Classes', 'Classes'); // Reference to the document containing the classes array
        const docSnapshot = await getDoc(docRef);

        if (!docSnapshot.exists()) {
          throw new Error('No classes document found.');
        }

        const classData = docSnapshot.data();
        if (classData.classes && Array.isArray(classData.classes)) {
          setClasses(classData.classes); // Set the classes array from the document
        } else {
          throw new Error('Classes data is not in the expected format.');
        }
      } catch (error) {
        console.error('Error fetching classes:', error);
        setSnackbar({ open: true, message: 'Error fetching classes: ' + error.message, severity: 'error' });
      }
    };

    fetchClasses();
  }, []);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      setSnackbar({ open: true, message: 'User not authenticated.', severity: 'error' });
      return;
    }

    try {
      const docRef = doc(db, 'hvac', 'GenericData', 'Classes', 'Classes'); // Reference to the document

      // Create the formatted string
      const classDataString = `${presenter}, ${className}, ${dateOfClass ? dateOfClass.toLocaleDateString() : ''}`;

      // Update the classes array in Firestore
      await updateDoc(docRef, {
        classes: [...classes, classDataString], // Add the new class data as a string to the existing array
      });

      setSnackbar({ open: true, message: 'Class added successfully!', severity: 'success' });
      setClassName(''); // Reset the class name
      setPresenter(''); // Reset the presenter
      setDateOfClass(null); // Reset the date of class
    } catch (error) {
      console.error('Error adding class:', error);
      setSnackbar({ open: true, message: 'Error adding class: ' + error.message, severity: 'error' });
    }
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', borderRadius: '12px' }}>
      <Typography variant="h4" gutterBottom>Add Class</Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel shrink>Class Name</InputLabel>
          <TextField
            value={className}
            onChange={(e) => setClassName(e.target.value)}
            required
            InputLabelProps={{ shrink: true }} // Ensure label does not overlap
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel shrink>Presenter</InputLabel>
          <TextField
            value={presenter}
            onChange={(e) => setPresenter(e.target.value)}
            required
            InputLabelProps={{ shrink: true }} // Ensure label does not overlap
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Date of Class"
              value={dateOfClass}
              onChange={(newValue) => setDateOfClass(newValue)}
              renderInput={(params) => <TextField {...params} required />}
            />
          </LocalizationProvider>
        </FormControl>
        <Button type="submit" variant="contained" color="primary">Submit</Button>
      </form>

      {/* Display the class information in bold */}
      {presenter && className && dateOfClass && (
        <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
          Class Display Name: {presenter}, {className}, {dateOfClass.toLocaleDateString()}
        </Typography>
      )}

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddClass;